// What a failed AI analysis tells anyone: never the provider, its key, its URLs or the raw error (server logs only).
const CONFIG = 'Le service d\'analyse IA n\'est pas correctement configuré. Prévenez l\'équipe data.';
const SATURATED = 'Le service d\'analyse IA est saturé. Réessayez dans quelques minutes avec Régénérer.';
const UNREACHABLE = 'Le service d\'analyse IA n\'a pas répondu. Réessayez avec Régénérer.';
const GENERIC = 'L\'analyse n\'a pas pu être générée. Réessayez avec Régénérer.';
const MESSAGES = [CONFIG, SATURATED, UNREACHABLE, GENERIC];

/** Error, error-like object or stored text → one of the four user-facing messages. */
export const analysisFailureMessage = (errorOrText) => {
  const text = typeof errorOrText === 'string'
    ? errorOrText
    : [errorOrText?.status, errorOrText?.code, errorOrText?.message].filter(Boolean).join(' ');

  if (MESSAGES.includes(text)) return text;

  const lower = text.toLowerCase();
  if (/\b40[13]\b/.test(lower) || lower.includes('api key') || lower.includes('invalid_api_key')) return CONFIG;
  if (/\b429\b/.test(lower) || lower.includes('rate limit') || lower.includes('quota')) return SATURATED;
  if (/etimedout|econnreset|timeout|socket/.test(lower)) return UNREACHABLE;
  return GENERIC;
};
